// Textos de la tienda: página Shop + galería «el juego de verdad».
// Traducción de fr/shop.js — exactamente las mismas claves.
// Los textos de producto (name, description, features de los packs) NO están
// aquí: vienen de la base de datos vía tp()/tpList() (ver LanguageContext).
export default {
  'shop.seo.titre': 'Tienda - Puzles que revelan el sexo del bebé',
  'shop.seo.description':
    "Dos packs Joyful Reveal para revelar el sexo del bebé en familia. Envío a España, Bélgica, Francia, Luxemburgo, Países Bajos y Alemania.",

  'shop.page.chargement': 'Cargando la tienda...',

  // Datos estructurados schema.org (CollectionPage) inyectados en el <head>.
  'shop.schema.nom': 'Tienda Mirum Games',
  'shop.schema.description': 'Descubra todos nuestros packs Joyful Reveal',

  'shop.entete.badge': '🛍️ Nuestra tienda',
  'shop.entete.titre': 'Joyful Reveal - Ositos',
  'shop.entete.texte':
    'Elija el pack perfecto para su momento mágico. Cada puzle es una creación especial para su familia.',

  // Ayuda a la elección: la frase va troceada porque «Essentiel» y «Premium»
  // están entre <strong> en el JSX. seg1+seg2+seg3+seg4+seg5 = la frase
  // completa; los espacios al principio y al final de los segmentos cuentan.
  'shop.aide.titre': 'Dos packs, un solo juego',
  'shop.aide.seg1': 'El ',
  'shop.aide.seg2': 'Essentiel',
  'shop.aide.seg3': ' si prepara usted mismo sus preguntas y sus equipos. El ',
  'shop.aide.seg4': 'Premium',
  'shop.aide.seg5':
    ' si quiere que todo llegue ya listo: las bolsitas, el cuestionario impreso y el sobre de recuerdo.',

  // Respaldos de producto: solo si la base de datos no da ni description ni
  // features (no debería pasar) — no son claves packs.*.
  'shop.produit.descriptionRepli':
    '¡Descubra este pack Joyful Reveal para una gender reveal party inolvidable!',
  'shop.produit.repliDuo1': '2 cajas de juego',
  'shop.produit.repliDuo2': 'Pack económico',
  'shop.produit.repliDuo3': 'Ideal para 2 fiestas',
  'shop.produit.repliFamille1': '3 kits completos',
  'shop.produit.repliFamille2': 'La mejor relación calidad-precio',
  'shop.produit.repliFamille3': 'Ideal para familias grandes',
  'shop.produit.repliPremium1': 'Juego completo',
  'shop.produit.repliPremium2': 'Accesorios incluidos',
  'shop.produit.repliPremium3': 'Calidad premium',
  'shop.produit.repliMixte1': 'Versión niña + niño',
  'shop.produit.repliMixte2': 'Ideal para gemelos',
  'shop.produit.repliMixte3': 'Pack completo',
  'shop.produit.repliDefaut1': 'Caja de juego gender reveal',
  'shop.produit.repliDefaut2': 'Fabricación artesanal',
  'shop.produit.repliDefaut3': 'Envío rápido',

  // Nombre del artículo tal y como entra en el carrito.
  'shop.panier.nomArticle': 'Joyful Reveal - Ositos - {nom}',
  'shop.panier.suffixeGarcon': ' (Niño)',
  'shop.panier.suffixeFille': ' (Niña)',

  'shop.grille.altPhoto': '{nom} — Joyful Reveal, juego de gender reveal, foto del producto',
  'shop.grille.rupture': '❌ AGOTADO',
  'shop.grille.bientotRetour': 'Pronto de nuevo disponible',
  'shop.grille.enStock': 'En stock',
  'shop.grille.voirPlus': 'Ver más',
  'shop.grille.autresCaracteristiques': '+{n} más',
  'shop.grille.epuise': 'Agotado',
  'shop.grille.ajoute': '✓ ¡Añadido!',
  'shop.grille.ajouter': '🛒 Añadir',
  'shop.grille.versPanier': '→ Al carrito',
  'shop.grille.ficheComplete': '📋 Ver la ficha completa',

  'shop.vide.titre': 'No se ha encontrado ningún pack',
  'shop.vide.texte': 'Pruebe con otro filtro',

  'shop.pourquoi.titre': '¿Por qué elegir Joyful Reveal?',
  'shop.pourquoi.emballageTitre': 'Embalaje premium',
  'shop.pourquoi.emballageTexte':
    'Cada puzle llega en un elegante embalaje de regalo, listo para regalar o para abrir juntos.',
  'shop.pourquoi.jeuTitre': 'Juego interactivo',
  'shop.pourquoi.jeuTexte':
    'Un concepto único que convierte la revelación en un momento de juego participativo, con preguntas y respuestas divertidas.',
  'shop.pourquoi.assemblageTitre': 'Fácil de montar',
  'shop.pourquoi.assemblageTexte':
    'Un puzle pensado para montarse fácilmente en familia durante el juego de preguntas y respuestas.',
  'shop.pourquoi.momentTitre': 'Momento mágico',
  'shop.pourquoi.momentTexte':
    'Cree un recuerdo inolvidable revelando juntos, en familia, el sexo del bebé.',
  'shop.pourquoi.expeditionTitre': 'Enviado desde Bélgica',
  'shop.pourquoi.expeditionTexte':
    'Salida en 1 o 2 días laborables hacia Bélgica, Francia y Luxemburgo. Embalaje reforzado.',
  'shop.pourquoi.retractationTitre': '14 días para cambiar de opinión',
  'shop.pourquoi.retractationTexte':
    'Derecho de desistimiento de 14 días desde la recepción, tal como establece la legislación europea sobre compras en línea.',

  'shop.cta.titre': '¿Listo para vivir la revelación mágica?',
  'shop.cta.texte': 'Elija su pack y cree un momento inolvidable con su familia',
  'shop.cta.bouton': '🛒 Descubrir los packs',

  'shop.modale.titre': 'Es para...',
  'shop.modale.sousTitre': 'Seleccione el sexo para su puzle',
  'shop.modale.garcon': 'Niño',
  'shop.modale.fille': 'Niña',
  'shop.modale.annuler': 'Cancelar',

  'shop.galerie.titre': 'El juego de verdad',
  'shop.galerie.sousTitre':
    'Fotos del producto tal y como lo recibe — sin sorpresas desagradables.',
  'shop.galerie.agrandir': 'Ampliar la foto: {titre}',
  'shop.galerie.fermer': 'Cerrar',
  'shop.galerie.boiteRectoTitre': 'La caja',
  'shop.galerie.boiteRectoLegende': 'El juego Joyful Reveal, listo para regalar.',
  'shop.galerie.boiteRectoAlt':
    'Caja del juego Joyful Reveal: dos ositos, pieza de puzle rascable «¿GIRL o BOY?»',
  'shop.galerie.contenuTitre': 'Lo que usted recibe',
  'shop.galerie.contenuLegende':
    'La caja, la ficha de preguntas de recuerdo y las dos bolsitas de equipo.',
  'shop.galerie.contenuAlt':
    'Contenido completo del juego Joyful Reveal: la caja, la ficha de preguntas de recuerdo y las dos bolsitas de tela',
  'shop.galerie.pochonsTitre': 'Los dos equipos',
  'shop.galerie.pochonsLegende': 'Dos bolsitas de tela para el Equipo 1 y el Equipo 2.',
  'shop.galerie.pochonsAlt':
    'Las dos bolsitas de tela del juego, etiquetadas Equipo 1 y Equipo 2, ilustradas con ositos',
  'shop.galerie.boiteVersoTitre': 'Cómo se juega',
  'shop.galerie.boiteVersoLegende': 'Los 4 pasos del juego, de 2 a 10 jugadores, unos 20 minutos.',
  'shop.galerie.boiteVersoAlt':
    'Dorso de la caja Joyful Reveal con los 4 pasos del juego, para 2 a 10 jugadores, 20 minutos',
};
